import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { PExpandAreaTriggerModule } from '@panaya/ui/p-expand-area-trigger';
import { PFieldModule } from '@panaya/ui/p-field';
import { PIconModule } from '@panaya/ui/p-icon';
import { PTooltipModule } from '@panaya/ui/p-tooltip';
import { BooleanTransformPipe, PipeModule } from '@panaya/ui/pipes';
import { MentionModule } from 'angular-mentions';
import { PFieldTextComponent } from './p-field-text.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [PFieldTextComponent],
    imports: [
        CommonModule,
        PExpandAreaTriggerModule,
        PFieldModule,
        PipeModule,
        MatInputModule,
        MentionModule,
        PIconModule,
        PTooltipModule,
        BooleanTransformPipe,
        TranslateModule
    ],
    exports: [PFieldTextComponent]
})
export class PFieldTextModule {}
